import RegisterTerminalAPI from '@/API/pos/register-terminal-api'

export default {
  namespaced: true,
  state: {
    enabled: true,
    terminals: [],
    terminalsFetched: false,
  },
  getters: {
    isModuleEnabled: (state: any) => state.enabled,
    terminals: (state: any) => state.terminals,
    totalCashiers: (state: any, getters: any, rootState: any, rootGetters: any) => rootState.subscription.subscription.total_cashiers?.[rootGetters['branches/currentBranchId']] ?? 0,
    subCashiersLimit: (state: any, getters: any, rootState: any, rootGetters: any) => (rootGetters['permissions/isSuperAdmin'] ? Infinity : (rootState.subscription.subscription.sub_cashiers_limit?.[rootGetters['branches/currentBranchId']] ?? 0)),
    canAddCashier: (state: any, getters: any) => getters.totalCashiers < getters.subCashiersLimit,
  },
  mutations: {
    SET_ENABLE_STATUS(state: any, status: boolean) {
      state.enabled = status
    },
    SET_TERMINALS(state: any, terminals: any) {
      state.terminals = terminals
      state.terminalsFetched = true
    },
  },
  actions: {
    async FETCH_TERMINALS(context: any) {
      await RegisterTerminalAPI.getTerminalsList(context.rootGetters['branches/currentBranchId']).then(res => {
        context.commit('SET_TERMINALS', res?.register_terminals ?? [])
      }).catch(e => console.log(e))
    },
  },
}
